"use client";

import React from "react";
import { Users, Briefcase } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const fleetData = [{
  id: "v1",
  name: "Executive Sedan",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/fleet_executive_sedan.png",
  passengers: 3,
  luggage: 3,
  description: "The standard for luxury business travel. Features premium leather seating, climate control, and a quiet, smooth ride perfect for working or relaxing on the go.",
  link: "/ReservationsPage"
}, {
  id: "v2",
  name: "Luxury SUV",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/fleet_luxury_suv.png",
  passengers: 6,
  luggage: 6,
  description: "Spacious and commanding. Ideal for small groups, families, or those requiring extra luggage capacity without compromising on premium comfort and style.",
  link: "/ReservationsPage"
}, {
  id: "v3",
  name: "Sprinter Van",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/fleet_sprinter_van.png",
  passengers: 14,
  luggage: 10,
  description: "The ultimate group transport solution. Offers generous headroom, captain's chairs, and ample space for corporate events, roadshows, or extended tours.",
  link: "/ReservationsPage"
}];
export default function FleetShowcase() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="fleet-showcase" className="bg-dark-section text-dark-foreground section-padding relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-5xl h-[500px] bg-primary/10 blur-[120px] rounded-full pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold mb-4 text-white">
            Our Premium Fleet
          </h2>
          <p className="text-muted font-sans max-w-2xl mx-auto text-base md:text-lg">
            Experience unparalleled comfort and style with our meticulously maintained selection of luxury vehicles, tailored for every occasion.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {fleetData.map((vehicle, i) => <div key={vehicle.id} data-index={i} className="bg-black/60 backdrop-blur-[8px] border border-white/20 rounded-xl overflow-hidden flex flex-col hover-lift group">
              <div className="relative aspect-[16/10] overflow-hidden bg-black/40">
                <img src={vehicle.image} data-wvc-srcset={`${vehicle.image}-wvc-srcset`} data-wvc-sizes={`${vehicle.image}-wvc-sizes`} alt={vehicle.name} className="w-full h-full object-cover transition-transform duration-[800ms] ease-out group-hover:scale-105" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-60" />
              </div>
              
              <div className="p-6 md:p-8 flex flex-col flex-grow">
                <h3 className="text-[28px] text-white font-display font-semibold mb-4 leading-tight">
                  {vehicle.name}
                </h3>
                
                <div className="flex items-center gap-6 mb-6 text-[14px] text-muted font-sans border-b border-white/10 pb-6">
                  <div className="flex items-center gap-2" title="Maximum Passengers">
                    <Users className="w-4 h-4 text-secondary" />
                    <span>Max {vehicle.passengers}</span>
                  </div>
                  <div className="flex items-center gap-2" title="Maximum Luggage">
                    <Briefcase className="w-4 h-4 text-secondary" />
                    <span>Max {vehicle.luggage}</span>
                  </div>
                </div>
                
                <p className="text-muted/90 font-sans text-sm leading-relaxed mb-8 flex-grow">
                  {vehicle.description}
                </p>
                
                <Link to={vehicle.link} className="btn-secondary w-full text-center mt-auto">
                  Reserve Now
                </Link>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}